import {
  MaatAuditPlanType as SERVICE_WORKER_MaatAuditPlanType
} from '../../../../ServiceWorker/src/constants/maat-audit-plan-type.constants';

export { SERVICE_WORKER_MaatAuditPlanType as MaatAuditPlanType };
